import React from 'react';

import FooterGlints from './FooterGlints';

const Footer = () => <FooterGlints />;

export default Footer;
